import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v8';

import packageJson from '../../package.json';
import { RootLayout } from '@/layouts';
import { allRoutes } from '@/routing/Router';
import { ApplicationProviders, RouteProviders } from './providers';
import { initializeMonitoring } from './monitoring';

export const bootstrapApplication = () => {
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Failed to find the root element');

  rootElement.setAttribute('version', packageJson.version.substring(1));
  initializeMonitoring();

  const router = createBrowserRouter([
    {
      element: <RouteProviders />,
      children: [
        {
          element: <RootLayout />,
          children: allRoutes,
        },
      ],
    },
  ]);

  createRoot(rootElement).render(
    <React.StrictMode>
      <ApplicationProviders>
        <RouterProvider router={router} />
      </ApplicationProviders>
    </React.StrictMode>,
  );
};
